/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  FETCH_ALGOS_LIST_REQUEST,
  FETCH_ALGOS_LIST_SUCCESS,
  FETCH_ALGOS_LIST_FAILURE,
  ALGOS_HEALTH_STATUS,
  ALGOS_LIST_CONFIG_LOADING_START,
  ALGOS_LIST_CONFIG_LOADING_STOP,
  ALGOS_LIST_CONFIG_SELECTED_DAY,
  ALGOS_LIST_CONFIG_SORTING,
  SUBSCRIBE_LITE_POSITION_UPDATES,
  ALGOS_LIST_COMMON_CHANGE,
  ALGOS_LIST_CONFIG_ERRORS,
  ALGOS_LIST_CHANGE_ENABLE,
  ALGOS_LIST_CHANGE_ENABLE_LOADING,
  ALGOS_LIST_CHANGE_MODAL_ERROR,
  ALGOS_LIST_CONFIG_TERMINATE_INIT,
  ALGOS_LIST_CONFIG_DUPLICATE_ALGO_INIT,
  ALGOS_LIST_COMMON_UPPEND_DATA,
  ALGOS_LIST_CONFIG_RENAME_INIT,
  ALGOS_LIST_CONFIG_DELETE_INIT,
  ALGOS_LIST_CHANGE_DELETE_ALGO,
  ALGOS_LIST_CHANGE_SELECT,
  ALGOS_LIST_CONFIG_FILTER,
  ALGOS_LIST_CHANGE_CLEAR_ALL_SELECT,
  ALGOS_LIST_CHANGE_BULK_SELECT,
  ALGOS_LIST_CONFIG_BULK_CLEAR,
  ALGOS_LIST_CONFIG_BULK_DELETE_INIT,
  ALGOS_LIST_CONFIG_BULK_DUPLICATE_INIT,
  ALGOS_LIST_CHANGE_BULK_DELETE_ALGO,
  ALGOS_LIST_CONFIG_PAGE_LOADING_TRUE,
  ALGOS_LIST_CONFIG_PAGE_LOADING_FALSE,
  ALGOS_LIST_UPDATE_SKIP_CLEANER,
  ALGO_STATUS_UPDATE,
  ALGOS_LIST_CONFIG_BULK_TERMINATE_INIT,
  ALGOS_LIST_CONFIG_BULK_SQOFF_TERMINATE_INIT,
  ALGOS_LIST_CONFIG_SET_TOTAL_PNL_LENGTH,
  ALGOS_LIST_CONFIG_CLIENT_WISE_SQOFF_TERMINATE_INIT,
  ALGOS_LIST_CONFIG_CLIENT_WISE_TERMINATE_INIT,
  ALGOS_LIST_CONFIG_CLIENT_WISE_SET_TARGET_INIT,
  ALGOS_LIST_CONFIG_MASS_PNL,
  ALGOS_LIST_CONFIG_TOGGLE_CLIENT_ID,
  ALGOS_LIST_CONFIG_BULK_ENABLE_INIT,
  ALGOS_LIST_CHANGE_BULK_ENABLE_ALGO,
  ALGOS_LIST_CHANGE_BULK_CLEAR_SPECIFIC,
  ALGOS_LIST_CONFIG_BULK_DISABLE_INIT,
  ALGOS_LIST_CHANGE_BULK_DISABLE_ALGO,
  ALGOS_LIST_CHANGE_SQOFF_LOADING,
  ALGOS_LIST_CONFIG_TOGGLE_MTM,
  ALGOS_LIST_CONFIG_MULTI_SELECT,
  ALGOS_LIST_CONFIG_SHIFT_PRESSED,
  ALGOS_LIST_CHANGE_SHIFT_SELECT,
  ALGOS_LIST_CHANGE_MULTIPLIER_LOADING,
  ALGOS_LIST_CHANGE_MULTIPLIER,
  ALGOS_LIST_CHANGE_MULTIPLIER_CACHE,
  ALGOS_LIST_CHANGE_MULTIPLIER_RESET,
  ALGOS_LIST_CONFIG_BULK_MULTIPLIER_INIT,
  ALGOS_LIST_CHANGE_BULK_MULTIPLIER,
  ALGOS_LIST_FORCE_UPDATE,
  ALGOS_LIST_CHANGE_BROKER,
  CACHE_ALGOS_LIST,
  ALGOS_LIST_CONFIG_BULK_MTM_MODIFY_INIT,
} from '../../constants/ActionTypes';
import { ALGO_TABLE_FILTER, ALGO_TABLE_SORT } from '../../constants/cookies';
import { errorHandler } from '../../helpers/error-handler';
import storage from '../../storage';
import {
  forcedLogout,
  getFormattedDateFromDateObject,
  readBuffer,
} from '../../utils';
import {
  updateRefreshHealthStatus,
  updateRefreshPositionsUpdates,
  updateCommonChange,
  updateToggleEnable,
  updateCommonUppendData,
  updateDeleteAlgo,
  updateToggleSelect,
  updateClearAllSelect,
  updateBulkSelect,
  updateBulkDeleteAlgo,
  updateRefreshStatusUpdate,
  updateToggleEnableLoading,
  updateBulkAlgoClearSpecific,
  updateBulkEnableDisableAlgo,
  updateChangeSqOffLoading,
  updateShiftSelect,
  updateMultiplierLoading,
  updateMultiplier,
  updateMultiplierCache,
  updateMultiplierReset,
  updateBulkMultiplier,
  updateBrokerChange,
} from './updaters';

const getFilterFromStorage = () => readBuffer(ALGO_TABLE_FILTER) || {};
const getSortFromStorage = () => storage.getItem(ALGO_TABLE_SORT) || {};

const list = (state = { isFetching: false, errorMessage: null }, action) => {
  switch (action.type) {
    case FETCH_ALGOS_LIST_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGOS_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
      };
    case FETCH_ALGOS_LIST_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const refresh = (
  state = {
    data: {},
    dataCached: {},
    isFetching: false,
    errorMessage: null,
    updateTime: new Date(),
    isUpdateSkipped: false,
    pnlUpdatedAt: new Date(),
    cacheUpdateTime: new Date(),
  },
  action
) => {
  switch (action.type) {
    case FETCH_ALGOS_LIST_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_ALGOS_LIST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
        updateTime: new Date(),
      };
    case FETCH_ALGOS_LIST_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case CACHE_ALGOS_LIST:
      return { ...state, dataCached: action.data, cacheUpdateTime: new Date() };
    case ALGOS_HEALTH_STATUS:
      const {
        data: dataAlgoHealthStatus,
        updateTime: updateTimeAlgoHealthStatus,
        isUpdateSkipped: isUpdateSkippedAlgoHealthStatus,
        dataCached: dataCachedAlgoHealthStatus,
      } = updateRefreshHealthStatus(state, action);

      return {
        ...state,
        data: dataAlgoHealthStatus,
        updateTime: updateTimeAlgoHealthStatus,
        isUpdateSkipped: isUpdateSkippedAlgoHealthStatus,
        dataCached: dataCachedAlgoHealthStatus,
      };
    case SUBSCRIBE_LITE_POSITION_UPDATES:
      // skip if page other than algos
      const urlPosUpdate = window.location.href;
      const algoIdPosUpdate = urlPosUpdate.substring(
        urlPosUpdate.lastIndexOf('/') + 1
      );
      // skip if page other than algos
      if (!algoIdPosUpdate.startsWith('algos')) {
        return state;
      }

      const {
        data: dataPositionUpdates,
        dataCached: dataCachedPositionUpdates,
        updateTime: updateTimePositionUpdates,
        isUpdateSkipped: UpdateSkippedPositionUpdates,
      } = updateRefreshPositionsUpdates(state, action);

      const positionsNow = new Date();
      const positionsdiffTime = Math.abs(positionsNow - state.pnlUpdatedAt);

      if (positionsdiffTime <= 1000) {
        return {
          ...state,
          data: dataPositionUpdates,
          dataCached: dataCachedPositionUpdates,
          updateTime: updateTimePositionUpdates,
          isUpdateSkipped: UpdateSkippedPositionUpdates,
        };
      }

      return {
        ...state,
        data: dataPositionUpdates,
        dataCached: dataCachedPositionUpdates,
        updateTime: updateTimePositionUpdates,
        isUpdateSkipped: UpdateSkippedPositionUpdates,
        pnlUpdatedAt: positionsNow,
      };

    case ALGO_STATUS_UPDATE:
      // skip if page other than algos
      const urlStatusUpdate = window.location.href;
      const algoIdStatusUpdate = urlStatusUpdate.substring(
        urlStatusUpdate.lastIndexOf('/') + 1
      );

      // skip if page other than algos
      if (!algoIdStatusUpdate.startsWith('algos')) {
        return state;
      }

      const {
        data: dataStatusUpdate,
        dataCached: dataCachedStatusUpdate,
        updateTime: updateTimeStatusUpdate,
        isUpdateSkipped: UpdateSkippedStatusUpdate,
      } = updateRefreshStatusUpdate(state, action);

      return {
        ...state,
        data: dataStatusUpdate,
        dataCached: dataCachedStatusUpdate,
        updateTime: updateTimeStatusUpdate,
        isUpdateSkipped: UpdateSkippedStatusUpdate,
      };
    case ALGOS_LIST_UPDATE_SKIP_CLEANER:
      if (!state.isUpdateSkipped) {
        return state;
      }

      const now = new Date();
      const diffTime = Math.abs(now - state.updateTime);

      if (diffTime < 10000) {
        return state;
      }

      return {
        ...state,
        updateTime: now,
        isUpdateSkipped: false,
      };
    case ALGOS_LIST_COMMON_CHANGE:
      const { data: dataCommonChange, dataCached: dataCachedCommonChange } =
        updateCommonChange(state, action);

      return {
        ...state,
        data: dataCommonChange,
        dataCached: dataCachedCommonChange,
        updateTime: new Date(),
      };
    case ALGOS_LIST_COMMON_UPPEND_DATA:
      const dataUppendData = updateCommonUppendData(state, action);

      return {
        ...state,
        data: dataUppendData,
        updateTime: new Date(),
      };
    case ALGOS_LIST_CHANGE_ENABLE:
      const { data: dataToggleEnable, dataCached: dataCachedToggleEnable } =
        updateToggleEnable(state, action);

      return {
        ...state,
        data: dataToggleEnable,
        dataCached: dataCachedToggleEnable,
        updateTime: new Date(),
      };
    case ALGOS_LIST_CHANGE_ENABLE_LOADING:
      const {
        data: dataToggleEnableLoading,
        dataCached: dataCachedToggleEnableLoading,
      } = updateToggleEnableLoading(state, action);

      return {
        ...state,
        data: dataToggleEnableLoading,
        dataCached: dataCachedToggleEnableLoading,
      };
    case ALGOS_LIST_CHANGE_DELETE_ALGO:
      const { data: dataDeleteAlgo } = updateDeleteAlgo(state, action);

      return {
        ...state,
        data: dataDeleteAlgo,
        updateTime: new Date(),
      };
    case ALGOS_LIST_CHANGE_SELECT:
      const { data: dataToggleSelect, dataCached: dataCachedToggleSelect } =
        updateToggleSelect(state, action);

      return {
        ...state,
        data: dataToggleSelect,
        dataCached: dataCachedToggleSelect,
      };
    case ALGOS_LIST_CHANGE_BULK_SELECT:
      const { data: dataBulkSelect, dataCached: dataCachedBulkSelect } =
        updateBulkSelect(state, action);

      return {
        ...state,
        data: dataBulkSelect,
        dataCached: dataCachedBulkSelect,
      };
    case ALGOS_LIST_CHANGE_CLEAR_ALL_SELECT:
      const { data: dataClearAllSelect, dataCached: dataCachedClearAllSelect } =
        updateClearAllSelect(state);

      return {
        ...state,
        data: dataClearAllSelect,
        dataCached: dataCachedClearAllSelect,
      };
    case ALGOS_LIST_CHANGE_BULK_DELETE_ALGO:
      const { data: dataBulkDeleteAlgo, dataCached: dataCachedBulkDeleteAlgo } =
        updateBulkDeleteAlgo(state, action);

      return {
        ...state,
        data: dataBulkDeleteAlgo,
        dataCached: dataCachedBulkDeleteAlgo,
        updateTime: new Date(),
      };
    case ALGOS_LIST_CHANGE_BULK_ENABLE_ALGO:
      const { data: dataBulkEnableAlgo, dataCached: dataCachedBulkEnableAlgo } =
        updateBulkEnableDisableAlgo(state, action, 'enable');

      return {
        ...state,
        data: dataBulkEnableAlgo,
        dataCached: dataCachedBulkEnableAlgo,
      };
    case ALGOS_LIST_CHANGE_BULK_DISABLE_ALGO:
      const {
        data: dataBulkDisableAlgo,
        dataCached: dataCachedBulkDisableAlgo,
      } = updateBulkEnableDisableAlgo(state, action, 'disable');

      return {
        ...state,
        data: dataBulkDisableAlgo,
        dataCached: dataCachedBulkDisableAlgo,
      };
    case ALGOS_LIST_CHANGE_BULK_MULTIPLIER:
      const { data: dataBulkMultiplier, dataCached: dataCachedBulkMultiplier } =
        updateBulkMultiplier(state, action);

      return {
        ...state,
        data: dataBulkMultiplier,
        dataCached: dataCachedBulkMultiplier,
      };
    case ALGOS_LIST_CHANGE_BULK_CLEAR_SPECIFIC:
      const {
        data: dataBulkAlgoClearSpecific,
        dataCached: dataCachedBulkAlgoClearSpecific,
      } = updateBulkAlgoClearSpecific(state, action);

      return {
        ...state,
        data: dataBulkAlgoClearSpecific,
        dataCached: dataCachedBulkAlgoClearSpecific,
      };
    case ALGOS_LIST_CHANGE_SQOFF_LOADING:
      const {
        data: dataChangeSqOffLoading,
        dataCached: dataCachedChangeSqOffLoading,
      } = updateChangeSqOffLoading(state, action);

      return {
        ...state,
        data: dataChangeSqOffLoading,
        dataCached: dataCachedChangeSqOffLoading,
      };
    case ALGOS_LIST_CHANGE_SHIFT_SELECT:
      const { data: dataShiftSelect, dataCached: dataCachedShiftSelect } =
        updateShiftSelect(state, action);

      return {
        ...state,
        data: dataShiftSelect,
        dataCached: dataCachedShiftSelect,
      };
    case ALGOS_LIST_CHANGE_MULTIPLIER_CACHE:
      const {
        data: dataMultiplierCache,
        dataCached: dataCachedMultiplierCache,
      } = updateMultiplierCache(state, action);

      return {
        ...state,
        data: dataMultiplierCache,
        dataCached: dataCachedMultiplierCache,
      };
    case ALGOS_LIST_CHANGE_MULTIPLIER_LOADING:
      const {
        data: dataMultiplierLoading,
        dataCached: dataCachedMultiplierLoading,
      } = updateMultiplierLoading(state, action);

      return {
        ...state,
        data: dataMultiplierLoading,
        dataCached: dataCachedMultiplierLoading,
      };
    case ALGOS_LIST_CHANGE_MULTIPLIER_RESET:
      const {
        data: dataMultiplierReset,
        dataCached: dataCachedMultiplierReset,
      } = updateMultiplierReset(state);

      return {
        ...state,
        data: dataMultiplierReset,
        dataCached: dataCachedMultiplierReset,
      };
    case ALGOS_LIST_CHANGE_MULTIPLIER:
      const { data: dataMultiplier, dataCached: dataCachedMultiplier } =
        updateMultiplier(state, action);

      return {
        ...state,
        data: dataMultiplier,
        dataCached: dataCachedMultiplier,
      };
    case ALGOS_LIST_FORCE_UPDATE:
      return {
        ...state,
        updateTime: new Date(),
      };
    case ALGOS_LIST_CHANGE_BROKER:
      const { data: dataChangeBroker, dataCached: dataCachedChangeBroker } =
        updateBrokerChange(state, action);

      return {
        ...state,
        data: dataChangeBroker,
        dataCached: dataCachedChangeBroker,
      };
    default:
      return state;
  }
};

const today = getFormattedDateFromDateObject(
  undefined,
  'ddd'
).toLocaleUpperCase();

const config = (
  state = {
    selectedDay: 'MON',
    today: today,
    totalPnlLength: 0,
    errors: {},
    modalErrors: {
      showError: false,
      error: {},
    },
    terminateData: {
      start: false,
      action: '',
      algoId: '',
    },
    duplicateAlgoData: {
      start: false,
      id: '',
      name: '',
      day: '',
      broker: '',
    },
    renameAlgoData: {
      start: false,
      id: '',
      name: '',
    },
    deleteAlgoData: {
      start: false,
      id: '',
    },
    bulkDeleteAlgoData: {
      start: false,
    },
    bulkDuplicateAlgoData: {
      start: false,
    },
    bulkTerminateAlgoData: {
      start: false,
    },
    bulkSqOffTerminateAlgoData: {
      start: false,
    },
    bulkEnableAlgoData: {
      start: false,
    },
    bulkDisableAlgoData: {
      start: false,
    },
    bulkMultiplierAlgoData: {
      start: false,
    },
    bulkMTMModifyAlgoData: {
      start: false,
    },
    clientWiseSqOffTerminateAlgoData: {
      start: false,
    },
    clientWiseTerminateAlgoData: {
      start: false,
    },
    clientWiseSetTargetData: {
      start: false,
    },
    filter: getFilterFromStorage(),
    filterUpdatedAt: Date.now(),
    loading: false,
    sorting: getSortFromStorage(),
    bulkSelectionValue: '',
    pageLoading: false,
    massPnl: {},
    clientIdShow: true,
    mtmShow: true,
    multiSelectSelected: '',
    shiftPressed: false,
  },
  action
) => {
  switch (action.type) {
    case ALGOS_LIST_CONFIG_LOADING_START:
      return {
        ...state,
        loading: true,
      };
    case ALGOS_LIST_CONFIG_LOADING_STOP:
      return {
        ...state,
        loading: false,
      };
    case ALGOS_LIST_CONFIG_SELECTED_DAY:
      return {
        ...state,
        selectedDay: action.data,
      };
    case ALGOS_LIST_CONFIG_SORTING:
      return {
        ...state,
        sorting: action.data,
      };
    case ALGOS_LIST_CONFIG_ERRORS:
      const processedError = errorHandler(action.data.error);

      if (
        processedError &&
        processedError.global &&
        processedError.global.toLowerCase() === 'unauthorized'
      ) {
        forcedLogout();
      }

      return {
        ...state,
        errors: processedError,
      };
    case ALGOS_LIST_CHANGE_MODAL_ERROR:
      return {
        ...state,
        modalErrors: action.data,
      };
    case ALGOS_LIST_CONFIG_TERMINATE_INIT:
      return {
        ...state,
        terminateData: action.data,
      };
    case ALGOS_LIST_CONFIG_DUPLICATE_ALGO_INIT:
      return {
        ...state,
        duplicateAlgoData: action.data,
      };
    case ALGOS_LIST_CONFIG_RENAME_INIT:
      return {
        ...state,
        renameAlgoData: action.data,
      };
    case ALGOS_LIST_CONFIG_DELETE_INIT:
      return {
        ...state,
        deleteAlgoData: action.data,
      };
    case ALGOS_LIST_CONFIG_FILTER:
      return {
        ...state,
        filter: action.data,
        filterUpdatedAt: Date.now(),
      };
    case ALGOS_LIST_CHANGE_BULK_SELECT:
      return {
        ...state,
        bulkSelectionValue: action.data.value,
      };
    case ALGOS_LIST_CONFIG_BULK_CLEAR:
      return {
        ...state,
        bulkSelectionValue: '',
      };
    case ALGOS_LIST_CONFIG_BULK_DELETE_INIT:
      return {
        ...state,
        bulkDeleteAlgoData: action.data,
      };
    case ALGOS_LIST_CONFIG_BULK_DUPLICATE_INIT:
      return {
        ...state,
        bulkDuplicateAlgoData: action.data,
      };
    case ALGOS_LIST_CONFIG_BULK_TERMINATE_INIT:
      return {
        ...state,
        bulkTerminateAlgoData: action.data,
      };
    case ALGOS_LIST_CONFIG_BULK_SQOFF_TERMINATE_INIT:
      return {
        ...state,
        bulkSqOffTerminateAlgoData: action.data,
      };
    case ALGOS_LIST_CONFIG_BULK_ENABLE_INIT:
      return {
        ...state,
        bulkEnableAlgoData: action.data,
      };
    case ALGOS_LIST_CONFIG_BULK_DISABLE_INIT:
      return {
        ...state,
        bulkDisableAlgoData: action.data,
      };
    case ALGOS_LIST_CONFIG_BULK_MULTIPLIER_INIT:
      return {
        ...state,
        bulkMultiplierAlgoData: action.data,
      };
    case ALGOS_LIST_CONFIG_BULK_MTM_MODIFY_INIT:
      return {
        ...state,
        bulkMTMModifyAlgoData: action.data,
      };
    case ALGOS_LIST_CONFIG_CLIENT_WISE_SQOFF_TERMINATE_INIT:
      return {
        ...state,
        clientWiseSqOffTerminateAlgoData: action.data,
      };
    case ALGOS_LIST_CONFIG_CLIENT_WISE_TERMINATE_INIT:
      return {
        ...state,
        clientWiseTerminateAlgoData: action.data,
      };
    case ALGOS_LIST_CONFIG_CLIENT_WISE_SET_TARGET_INIT:
      return {
        ...state,
        clientWiseSetTargetData: action.data,
      };
    case ALGOS_LIST_CONFIG_PAGE_LOADING_TRUE:
      return {
        ...state,
        pageLoading: true,
      };
    case ALGOS_LIST_CONFIG_PAGE_LOADING_FALSE:
      return {
        ...state,
        pageLoading: false,
      };
    case ALGOS_LIST_CONFIG_SET_TOTAL_PNL_LENGTH:
      return {
        ...state,
        totalPnlLength: action.value,
      };
    case ALGOS_LIST_CONFIG_MASS_PNL:
      return {
        ...state,
        massPnl: action.data,
      };
    case ALGOS_LIST_CONFIG_TOGGLE_CLIENT_ID:
      return {
        ...state,
        clientIdShow: !state.clientIdShow,
      };
    case ALGOS_LIST_CONFIG_TOGGLE_MTM:
      return {
        ...state,
        mtmShow: !state.mtmShow,
      };
    case ALGOS_LIST_CONFIG_MULTI_SELECT:
      return {
        ...state,
        multiSelectSelected: action.data.id,
      };
    case ALGOS_LIST_CONFIG_SHIFT_PRESSED:
      return {
        ...state,
        shiftPressed: action.data,
      };

    default:
      return state;
  }
};

const algosList = combineReducers({
  list,
  refresh,
  config,
});

export default algosList;
